import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Box,
  Grid,
  IconButton,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Button,
  TableBody,
  Typography,
  Switch,
  Checkbox,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { MultiSelect } from "react-multi-select-component";
import React, { useState } from "react";
import { CustomInputField } from "../CommonComponents/CustomCompontes";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import { companyWiseEmp } from "../../actions/Companywiseclient";

function BankDetailsConfiguration({ companyId }) {
  const [bankDetailsList, setBankDetailsList] = useState([]);
  const [itemToUpdate, setItemToUpdate] = useState(null);
  const [formData, setFormData] = useState({
    accountHolder: "",
    branch: "",
    accountNumber: "",
    bankName: "",
    ifsc: "",
    uploadQR: null,
  });

  const handleChange = (e) => {
    if (e.target.name === "uploadQR") {
      if (
        e.target.files[0] &&
        !["image/png", "image/jpeg"].includes(e.target.files[0].type)
      ) {
        setFormData({
          ...formData,
          [e.target.name]: null,
        });
        return alert("Please provide PNG Or JPEG File.");
      } else {
        setFormData({
          ...formData,
          [e.target.name]: e.target.files[0] || null,
        });
      }
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const handleAddBankDetail = async () => {
    if (
      !Boolean(formData.accountNumber.trim()) ||
      !Boolean(formData.bankName.trim()) ||
      !Boolean(formData.ifsc.trim()) ||
      !Boolean(formData.accountHolder.trim()) ||
      !Boolean(formData.branch.trim())
    ) {
      return alert("All the fields are required.");
    }
    //  else if (!Boolean(formData.uploadQR)) {
    //   return alert("Please Select QR code.");
    // }

    const payload = new FormData();
    payload.append("companyId", companyId);
    payload.append("accountNumber", formData.accountNumber);
    payload.append("bankName", formData.bankName);
    payload.append("ifscCode", formData.ifsc);
    payload.append("accountHolderName", formData.accountHolder);
    payload.append("branchName", formData.branch);
    if (Boolean(formData.uploadQR) && typeof formData.uploadQR !== "string") {
      payload.append("file", formData.uploadQR);
    }
    if (Boolean(formData.uploadQR) && typeof formData.uploadQR === "string") {
      payload.append("qrCodeUrl", formData.uploadQR);
    }
    if (Boolean(itemToUpdate)) {
      payload.append("id", itemToUpdate.id);
      payload.append("isDefaultBank", itemToUpdate.isDefaultBank);
      payload.append("isActive", itemToUpdate.isActive);
    }

    const res = await companyWiseEmp.saveBankDetailsByCompany(payload);
    if (res.data && res.data.responseCode === 200) {
      getSetBankDetailsList();
      alert(
        Boolean(itemToUpdate)
          ? "Bank details updated successfully."
          : "Bank details added successfully."
      );
      setFormData({
        accountNumber: "",
        bankName: "",
        ifsc: "",
        uploadQR: null,
        accountHolder: "",
        branch: "",
      });
      setItemToUpdate(null);
    } else {
      alert(res.response?.data?.responseDescription || "Something Went Wrong.");
    }
  };

  const getSetBankDetailsList = async () => {
    const res = await companyWiseEmp.fetchAllBankDetailsByCompany(companyId);
    if (res !== null) {
      setBankDetailsList(res.data);
    }
  };

  const handleUpdateStatus = async (status, detail) => {
    const payload = new FormData();
    payload.append("id", detail.id);
    payload.append("isActive", status);
    payload.append("isDefaultBank", detail.isDefaultBank);
    payload.append("companyId", companyId);
    payload.append("accountNumber", detail.accountNumber);
    payload.append("bankName", detail.bankName);
    payload.append("ifscCode", detail.ifscCode);
    payload.append("accountHolderName", detail.accountHolderName);
    payload.append("branchName", detail.branchName);
    if (Boolean(detail.qrCodeUrl)) {
      payload.append("qrCodeUrl", detail.qrCodeUrl);
    }
    const res = await companyWiseEmp.saveBankDetailsByCompany(payload);
    if (res.data && res.data.responseCode === 200) {
      getSetBankDetailsList();
      alert("Status Updated Successfully.");
      setItemToUpdate(null);
    } else {
      alert(res.response?.data?.responseDescription || "Something Went Wrong.");
    }
  };

  const handleUpdateDefault = async (status, detail) => {
    const payload = new FormData();
    payload.append("id", detail.id);
    payload.append("isActive", detail.isActive);
    payload.append("isDefaultBank", status);
    payload.append("companyId", companyId);
    payload.append("accountNumber", detail.accountNumber);
    payload.append("bankName", detail.bankName);
    payload.append("ifscCode", detail.ifscCode);
    payload.append("accountHolderName", detail.accountHolderName);
    payload.append("branchName", detail.branchName);
    if (Boolean(detail.qrCodeUrl)) {
      payload.append("qrCodeUrl", detail.qrCodeUrl);
    }
    const res = await companyWiseEmp.saveBankDetailsByCompany(payload);
    if (res.data && res.data.responseCode === 200) {
      getSetBankDetailsList();
      alert("Default Bank updated Successfully");
      setItemToUpdate(null);
    } else {
      alert(res.response?.data?.responseDescription || "Something Went Wrong.");
    }
  };

  React.useEffect(() => {
    getSetBankDetailsList();
  }, [companyId]);

  React.useEffect(() => {
    if (Boolean(itemToUpdate)) {
      setFormData({
        accountNumber: itemToUpdate.accountNumber,
        bankName: itemToUpdate.bankName,
        ifsc: itemToUpdate.ifscCode,
        uploadQR: itemToUpdate.qrCodeUrl || null,
        accountHolder: itemToUpdate.accountHolderName || "",
        branch: itemToUpdate.branchName || "",
      });
    } else {
      setFormData({
        accountNumber: "",
        bankName: "",
        ifsc: "",
        uploadQR: null,
        accountHolder: "",
        branch: "",
      });
    }
  }, [itemToUpdate]);

  return (
    <div>
      {/* <Grid className="CompanyBox"> */}
      <Accordion className="main_accoardian" defaultExpanded={true}>
        <AccordionSummary
          className="accordianHeader"
          expandIcon={
            <AddCircleIcon fontSize="large" style={{ color: "white" }} />
          }
          aria-controls="panel1a-content"
          style={{
            background: "rgb(10 166 141)",
            borderRadius: "10px 10px 0px 0px",
            overflow: "hidden",
          }}
        >
          <Grid>
            <Grid>
              <h3
                style={{
                  color: "#fff",
                  marginLeft: "10px",
                  padding: "10px 2px",
                }}
              >
                BankDetails Configuration:-
              </h3>
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          <Box sx={{ my: 1 }}>
            <Grid
              container
              direction="row"
              //justifyContent="center"
              spacing={3}
              alignItems="center"
            >
              <Grid item xs={12}>
                <Grid
                  container
                  direction="row"
                  //justifyContent="center"
                  spacing={3}
                  alignItems="center"
                >
                  <Grid item md={3.55} lg={2.75} xl={2.25}>
                    <CustomInputField
                      sx={{
                        width: "100%",
                        margin: "0px !important",
                      }}
                      required
                      id="outlined-basic"
                      label="Account Holder"
                      name="accountHolder"
                      variant="outlined"
                      size="small"
                      inputProps={{ maxLength: 200 }}
                      value={formData.accountHolder}
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item md={3.55} lg={2.75} xl={2.25}>
                    <CustomInputField
                      sx={{
                        width: "100%",
                        margin: "0px !important",
                      }}
                      required
                      id="outlined-basic"
                      label="Bank Name"
                      name="bankName"
                      variant="outlined"
                      size="small"
                      inputProps={{ maxLength: 200 }}
                      value={formData.bankName}
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item md={3.55} lg={2.75} xl={2.25}>
                    <CustomInputField
                      sx={{
                        width: "100%",
                        margin: "0px !important",
                      }}
                      required
                      id="outlined-basic"
                      label="Account Number"
                      name="accountNumber"
                      variant="outlined"
                      size="small"
                      inputProps={{ maxLength: 25 }}
                      value={formData.accountNumber}
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item md={3.55} lg={2.75} xl={2.25}>
                    <CustomInputField
                      sx={{
                        width: "100%",
                        margin: "0px !important",
                      }}
                      required
                      id="outlined-basic"
                      label="IFSC"
                      name="ifsc"
                      variant="outlined"
                      size="small"
                      inputProps={{ maxLength: 25 }}
                      value={formData.ifsc}
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item md={3.55} lg={2.75} xl={2.25}>
                    <CustomInputField
                      sx={{
                        width: "100%",
                        margin: "0px !important",
                      }}
                      required
                      id="outlined-basic"
                      label="Branch"
                      name="branch"
                      variant="outlined"
                      size="small"
                      inputProps={{ maxLength: 200 }}
                      value={formData.branch}
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item md={3.55} lg={2.75} xl={2.25}>
                    {Boolean(formData.uploadQR) ? (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={
                            typeof formData.uploadQR === "string"
                              ? formData.uploadQR
                              : URL.createObjectURL(formData.uploadQR)
                          }
                          alt="QR Code"
                          width="50"
                        />
                        <IconButton
                          onClick={() =>
                            setFormData({ ...formData, uploadQR: null })
                          }
                        >
                          <CloseIcon />
                        </IconButton>
                      </Box>
                    ) : (
                      <CustomInputField
                        sx={{
                          width: "100%",
                          margin: "0px !important",
                        }}
                        // required
                        id="outlined-basic"
                        label="Upload QR"
                        name="uploadQR"
                        variant="outlined"
                        size="small"
                        type="file"
                        InputLabelProps={{ shrink: true }}
                        inputProps={{
                          accept: "image/png, image/jpeg",
                        }}
                        onChange={handleChange}
                      />
                    )}
                  </Grid>
                  <Grid item>
                    <div
                      className="field_box"
                      style={{
                        // backgroundColor: "orange",
                        paddingBottom: "12px",
                      }}
                    >
                      <div
                        className="field_box_btn1"
                        style={{
                          cursor: "pointer",
                        }}
                        onClick={handleAddBankDetail}
                      >
                        {Boolean(itemToUpdate) ? "Update" : "Add"}
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <TableContainer>
              <Table size="small">
                <TableHead sx={{ backgroundColor: "#32577e" }}>
                  <TableRow>
                    <TableCell
                      sx={{ color: "#fff", fontWeight: "bold", fontSize: 16 }}
                    >
                      Sl no.
                    </TableCell>
                    <TableCell
                      sx={{ color: "#fff", fontWeight: "bold", fontSize: 16 }}
                    >
                      Bank Details
                    </TableCell>
                    <TableCell
                      sx={{ color: "#fff", fontWeight: "bold", fontSize: 16 }}
                    >
                      QR Code
                    </TableCell>
                    <TableCell
                      sx={{ color: "#fff", fontWeight: "bold", fontSize: 16 }}
                    >
                      Status
                    </TableCell>
                    <TableCell
                      sx={{ color: "#fff", fontWeight: "bold", fontSize: 16 }}
                    >
                      Default
                    </TableCell>
                    <TableCell
                      sx={{ color: "#fff", fontWeight: "bold", fontSize: 16 }}
                    >
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {bankDetailsList.map((detail, index) => {
                    return (
                      <TableRow key={detail.id}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>
                          <Typography variant="body1">
                            <span style={{ fontWeight: "bold" }}>
                              Account Holder:{" "}
                            </span>{" "}
                            {detail.accountHolderName}
                          </Typography>
                          <Typography variant="body1">
                            <span style={{ fontWeight: "bold" }}>
                              Bank Name:{" "}
                            </span>
                            {detail.bankName}
                          </Typography>
                          <Typography variant="body1">
                            <span style={{ fontWeight: "bold" }}>A/C No: </span>{" "}
                            {detail.accountNumber}
                          </Typography>
                          <Typography variant="body1">
                            <span style={{ fontWeight: "bold" }}>IFSC: </span>
                            {detail.ifscCode}
                          </Typography>
                          <Typography variant="body1">
                            <span style={{ fontWeight: "bold" }}>Branch: </span>{" "}
                            {detail.branchName}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <a href={detail.qrCodeUrl} target="_blank">
                            QR Code
                          </a>
                        </TableCell>
                        <TableCell>
                          <Switch
                            checked={detail.isActive}
                            onChange={(e) =>
                              handleUpdateStatus(e.target.checked, detail)
                            }
                          />
                        </TableCell>
                        <TableCell>
                          <Checkbox
                            checked={detail.isDefaultBank}
                            onChange={(e) =>
                              handleUpdateDefault(e.target.checked, detail)
                            }
                            color="primary"
                          />
                        </TableCell>
                        <TableCell>
                          <IconButton onClick={() => setItemToUpdate(detail)}>
                            <EditIcon color="success" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </AccordionDetails>
      </Accordion>
      {/* </Grid> */}
    </div>
  );
}

function CustomRow({ detail }) {
  return;
}

export default BankDetailsConfiguration;
